import { TASKS_API_BASE_URL_V7 } from '../config';

export const TasksAPIRoutes = {
  getTaskStatus: () => `${TASKS_API_BASE_URL_V7}/status`,
};
